import { contractTitle } from './contractTitle';

type SigningLocation = Pick<Location, 'assign'>;

export type SigningHandoffState = {
  signingUrl?: string;
  returnPath?: string;
  contractLabel?: string;
  provider?: string;
  processId?: string;
  autoOpen?: boolean;
};

export function signingHandoffDestination(contractId: string, signing: {
  signingUrl: string;
  provider: string;
  externalSigningProcessId: string;
  contract?: { projectId?: string; contractName?: string | null; description?: string | null };
}) {
  if (!signing.signingUrl || !signing.externalSigningProcessId) throw new Error('Missing signing room.');
  return {
    path: `/contracts/${encodeURIComponent(contractId)}/signing`,
    state: {
      provider: signing.provider,
      signingUrl: signing.signingUrl,
      processId: signing.externalSigningProcessId,
      contractLabel: (signing.contract && contractTitle(signing.contract)) || undefined,
      returnPath: signing.contract?.projectId
        ? `/projects/${encodeURIComponent(signing.contract.projectId)}?tab=contract&contractId=${encodeURIComponent(contractId)}`
        : '/projects',
      autoOpen: true,
    } satisfies SigningHandoffState,
  };
}

export function validZignedSigningUrl(value: string) {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && ['zigned.se', 'www.zigned.se'].includes(url.hostname)
      && url.pathname.startsWith('/sign/') && !url.username && !url.password;
  } catch {
    return false;
  }
}

export function redirectToExternalSigning(
  signingUrl: string,
  browserLocation: SigningLocation = window.location
): void {
  browserLocation.assign(signingUrl);
}
